export default class GtmWatch {
  static init(){
    this.bindFacebookShareButtonClick();
    this.bindTwitterShareButtonClick();
    this.bindEmbedShareButtonClick();
  }

  static bindFacebookShareButtonClick() {
    $(".popup-embed__share-facebook[data-source='vod-watchpage']").click(function() {
      GtmWatch.push('click', 'share', 'watchpage/facebook', 'vod.'+this.getAttribute('data-video-id'));
    });
  }

  static bindTwitterShareButtonClick() {
    $(".popup-embed__share-twitter[data-source='vod-watchpage']").click(function() {
      GtmWatch.push('click', 'share', 'watchpage/twitter', 'vod.'+this.getAttribute('data-video-id'));
    });
  }

  static bindEmbedShareButtonClick() {
    $(".popup-embed__tab #embed-tab[data-source='vod-watchpage']").click(function() {
      GtmWatch.push('click', 'share', 'watchpage/embed', 'vod.'+this.getAttribute('data-video-id'));
    });
  }

  static push(event,featureName,featureLocation,featureType){
    window.dataLayer.push({
      event: event,
      feature_name: featureName,
      feature_location: featureLocation,
      feature_type: featureType
    });
  }
}
